import { Row } from 'react-bootstrap';
import styled from 'styled-components';
import { breakpoints } from 'styles/mediaQuery';

export const DividerLabel = styled.p`
  width: 100%;
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-top: 15px;
  margin-bottom: 25px;

  &::after {
    content: '';
    width: 100%;
    height: 1px;
    background-color: #ddd;
    margin-left: 8px;
  }
`;

export const MappingTypeContainer = styled.div`
  position: relative;

  .form-field-container div:has(select) {
    padding-right: 79px;
  }

  &.has-right-tooltip {
    .form-field-container div:has(select) {
      padding-right: 25px;
    }

    .form-field-container label + div:has(input[type='radio']) {
      padding-right: 50px;
    }
  }

  & > svg {
    position: absolute;
    right: 50px;
    top: 2px;
    width: 24px;
    height: 24px;
  }

  &.has-error {
    select {
      color: #a94442;
    }

    svg {
      opacity: 0.6;
    }
  }
`;

export const RadioOptionsContainer = styled(MappingTypeContainer)`
  position: relative;

  .form-field-container div div {
    margin-top: 0;
  }

  .form-group {
    margin-bottom: 0;
  }

  .row {
    margin-bottom: 14px;
  }
`;

export const RadioIconsContainer = styled.div`
  position: absolute;
  right: 0px;
  top: 6px;

  display: flex;
  align-items: center;
  gap: 5px;

  svg {
    width: 18px;
    height: 18px;
  }

  @media (min-width: ${breakpoints.XS}px) {
    right: 50px;
    top: 2px;

    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

export const ConditionContainer = styled.div`
  .form-field-container {
    margin-bottom: 0;
  }
`;

export const IsOptionalFieldRow = styled(Row)`
  span {
    margin-top: 2px;
  }

  .checkbox {
    padding-top: 0;
  }
`;

export const NightFieldContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;

  select {
    width: 60px;
  }
`;
